// function playWishlistSound() {
//     const audio = new Audio('/wp-content/themes/starter/dist/images/sounds/do-ulubionych.mp3');
//     audio.play();
// }

function playSearchSound() {
    const audio = new Audio('/wp-content/themes/starter/dist/images/sounds/szukaj.mp3');
    audio.play();
}


document.addEventListener('DOMContentLoaded', function () {
    const wishlistButtons = document.querySelectorAll('.tinvwl_add_to_wishlist_button');

    wishlistButtons.forEach((button) => {
        if (!button.classList.contains('tinvwl-product-in-list')) {
            button.addEventListener('click', () => {
                playWishlistSound();
            });
        }
    });

    // const searchButton = document.getElementById('dgwt-wcas-search-input-1');
    // searchButton.addEventListener('click', () => {
    //     playSearchSound();
    // });
});
